<template>
  <div class="rsu viewModal">
    <div class="viewModalHeader">
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-righ ab-close-icon">
            <v-btn class="ma-0 color-white" @click="$emit('close')" icon
              ><v-icon>close</v-icon></v-btn
            >
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="headline primary--text mb-1">
            <Typography
              h2
              bold
              color="color-white"
              :label="`${formdata.formname ? formdata.formname : 'ชื่อโครงการ'}`"
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="viewModalSubHeader">
      <v-layout row wrap class="ma-0">
        <v-flex xs12>
          <div class="subContainer">
            <img
              :src="`/static/icon/${'viewSvg'}.svg`"
              alt
              class="responsive-img table-ico mr-2"
              style="height: 15px"
            />
            <Typography h5 semiBold color="color-darkBlue" label="โหมดตัวอย่าง" />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="viewModalBody">
      <v-layout row wrap class="ma-0">
        <v-flex xs12>
          <v-layout row wrap class="ma-0">
            <v-flex xs12 v-for="(formitem, k) in allform" :key="k" class="form-control">
              <div class="grey--text rsu" v-if="formitem.hideFromMember">
                ** Question นี้จะถูกซ่อนจากสมาชิก
              </div>
              <div class="mb-2" v-if="['หัวข้อ'].includes(formitem.questiontype)">
                <Typography
                  h3
                  semiBold
                  color="darkGrey"
                  :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-divider style="border-color:#BECCDB" />
              </div>
              <div
                class="mb-2"
                v-if="['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ'].includes(formitem.questiontype)"
              >
                <div class="input-ans">
                  <Typography
                    h5
                    semiBold
                    color="darkGrey"
                    :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
                    :label="formitem.name"
                  />
                  <input
                    :name="'form' + k"
                    :placeholder="customPlaceholder(formitem.Options)"
                    type="text"
                    class="depainput rsu mb-0"
                    readonly
                  />
                </div>
              </div>
              <div class="mb-2" v-if="['บทความ'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
              </div>
              <div class="mb-2" v-if="['วัน/เวลา'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="customDateOptions(formitem.Options)"
                />
                <v-layout row wrap class="ma-0">
                  <v-flex xs4 v-if="formitem.Options === 'all' || formitem.Options === 'date'">
                    <date-picker
                      :append-to-body="false"
                      :clearable="false"
                      :popup-style="{ visibility: 'hidden' }"
                      :editable="false"
                      :name="`date-${formitem.Options}`"
                      valueType="date"
                      format="DD/MM/YYYY"
                      placeholder="เลือกวันที่"
                      readonly
                      confirm
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </v-flex>
                  <v-flex
                    xs4
                    v-if="formitem.Options === 'all' || formitem.Options === 'time'"
                    :class="formitem.Options === 'all' ? 'ml-3' : ''"
                  >
                    <date-picker
                      :append-to-body="false"
                      :clearable="false"
                      :popup-style="{ visibility: 'hidden' }"
                      :editable="false"
                      :name="`date-${formitem.Options}`"
                      valueType="format"
                      format="HH:mm"
                      type="time"
                      placeholder="เลือกเวลา"
                      readonly
                      confirm
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </v-flex>
                </v-layout>
              </div>
              <div class="mb-2" v-if="['อัปโหลดไฟล์'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-btn
                  class="rsu customConfirmBtn ma-0 uploadBtn"
                  round
                  depressed
                  color="primary"
                  readonly
                >
                  <img
                    :src="`/static/icon/uploadYellowSvg.svg`"
                    alt
                    class="responsive-img mr-2"
                    style="height: 13px;"
                  />
                  อัปโหลดไฟล์
                </v-btn>
                <Typography
                  h7
                  medium
                  color="color-lightMediumGrey"
                  class="mt-1"
                  label="(จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)"
                />
              </div>
              <div class="mb-2" v-if="['อัปโหลดลายเซ็น'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-btn
                  class="rsu customConfirmBtn ma-0 uploadBtn"
                  round
                  depressed
                  color="primary"
                  readonly
                >
                  <img
                    :src="`/static/icon/uploadYellowSvg.svg`"
                    alt
                    class="responsive-img mr-2"
                    style="height: 13px;"
                  />
                  อัปโหลดลายเซ็น
                </v-btn>
                <Typography
                  h7
                  medium
                  color="color-lightMediumGrey"
                  class="mt-1"
                  label="(จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)"
                />
              </div>
              <div class="mb-2" v-if="['ช่องกรอกลิงก์'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <input
                  :name="'form' + k"
                  placeholder="http://www.example.com"
                  type="text"
                  class="depainput rsu mb-0"
                  readonly
                />
              </div>
              <div class="mb-2" v-if="['แนบลิงก์'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <a :href="formitem.URL" target="_blank">
                  <Typography
                    h5
                    medium
                    color="color-primary"
                    class="mt-1 linkText"
                    :label="formitem.URL"
                  />
                </a>
              </div>
              <div class="mb-2" v-if="['ตัวอย่างไฟล์'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-btn
                  :href="formitem.fileurl"
                  target="_blank"
                  class="rsu customExamfileBtn ma-0"
                  round
                  depressed
                  readonly
                >
                  <img :src="`/static/icon/fileSvg.svg`" alt class="responsive-img" />
                  <Typography
                    h5
                    bold
                    color="color-mediumBlue"
                    class="customBtnText"
                    :label="formitem.filename"
                  />
                </v-btn>
              </div>
              <div class="mb-2" v-if="['รูปภาพ'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-flex xs10>
                  <img :src="formitem.imgFile" alt class="responsive-img w-80" />
                </v-flex>
              </div>
              <div class="mb-2" v-if="['ตัวเลข'].includes(formitem.questiontype)">
                <v-flex xs12 style="display: flex;" class="mb-1">
                  <Typography h5 semiBold color="darkGrey" class="mr-1" :label="formitem.name" />
                  <Typography
                    h5
                    semiBold
                    color="color-lightMediumGrey"
                    :label="`(กรุณาใส่ตัวเลข${formitem.digitPosition}หลัก)`"
                    :class="`${formitem.isRequired ? 'dataReq' : ''}`"
                  />
                </v-flex>
                <input
                  :name="'form' + k"
                  placeholder=""
                  type="text"
                  class="depainput rsu mb-0"
                  readonly
                />
              </div>
              <div class="mb-2" v-if="['รายการผลิตภัณฑ์'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-radio-group
                  v-bind:value="
                    (formitem.Options = formitem.Options || 'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน')
                  "
                  v-on:change="formitem.Options = $event"
                  class="mt-0 d-block"
                >
                  <v-radio
                    checked
                    color="primary"
                    label="เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน"
                    :value="'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน'"
                  ></v-radio>
                  <DropdownMenu
                    v-if="formitem.Options == 'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน'"
                    :textLabel="''"
                    :options="[]"
                  >
                    <div style="position: relative" class="form-control">
                      <input
                        placeholder="เลือกผลิตภัณฑ์"
                        type="text"
                        class="option-input rsu"
                        style="cursor: pointer"
                        readonly
                      />
                    </div>
                  </DropdownMenu>
                  <v-radio
                    color="primary"
                    label="เพิ่มผลิตภัณฑ์ใหม่"
                    :value="'เพิ่มผลิตภัณฑ์ใหม่'"
                  ></v-radio>
                  <v-btn
                    v-if="formitem.Options == 'เพิ่มผลิตภัณฑ์ใหม่'"
                    class="rsu customConfirmBtn ma-0 uploadBtn"
                    round
                    depressed
                    color="primary"
                    readonly
                  >
                    <img
                      :src="`/static/icon/addYellowSvg.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 17px;"
                    />
                    เพิ่มผลิตภัณฑ์
                  </v-btn>
                </v-radio-group>
              </div>
              <div class="mb-2" v-if="['ตาราง'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-flex xs12 v-if="formitem.formTable.data.length">
                  <template>
                    <v-layout row wrap class="ma-0">
                      <div class="generate-table-container">
                        <table class="form-generate-table">
                          <thead>
                            <tr>
                              <th
                                v-for="(header, headerIndex) in formitem.formTable.data[0]"
                                :key="headerIndex"
                                :class="
                                  !formitem.formTable.viewColumn && headerIndex === 0
                                    ? 'd-none'
                                    : ''
                                "
                              >
                                <v-text-field
                                  v-if="headerIndex === 0"
                                  solo
                                  v-model="formitem.formTable.data[0][headerIndex]"
                                  class="editTextTable firstItem rsu"
                                  single-line
                                  readonly
                                >
                                </v-text-field>
                                <v-text-field
                                  v-if="headerIndex != 0"
                                  solo
                                  v-model="formitem.formTable.data[0][headerIndex]"
                                  class="editTextTable rsu"
                                  single-line
                                  readonly
                                >
                                </v-text-field>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(row, rowIndex) in formitem.formTable.data.slice(1)"
                              :key="rowIndex"
                            >
                              <td
                                v-for="(column, columnIndex) in row"
                                :key="columnIndex"
                                :class="
                                  !formitem.formTable.viewColumn && columnIndex === 0
                                    ? 'd-none'
                                    : ''
                                "
                              >
                                <v-text-field
                                  v-if="columnIndex === 0"
                                  solo
                                  v-model="formitem.formTable.data[rowIndex + 1][0]"
                                  class="editTextTable rsu"
                                  single-line
                                  readonly
                                >
                                </v-text-field>
                                <v-text-field
                                  v-else
                                  solo
                                  v-model="formitem.formTable.data[rowIndex + 1][columnIndex]"
                                  class="editTextTable rsu"
                                  single-line
                                  readonly
                                >
                                </v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-layout>
                  </template>
                </v-flex>
              </div>
              <div class="mb-2" v-if="['ที่อยู่'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-layout row wrap class="ma-0">
                  <v-flex xs12 class="mb-2">
                    <input
                      :name="'บ้านเลขที่' + k"
                      placeholder="(บ้านเลขที่)"
                      type="text"
                      class="depainput rsu mb-0"
                      readonly
                    />
                  </v-flex>
                  <v-flex xs6 class="mb-2 pr-2">
                    <input
                      :name="'รหัสไปรษณีย์' + k"
                      placeholder="(รหัสไปรษณีย์)"
                      type="text"
                      class="depainput rsu mb-0"
                      readonly
                  /></v-flex>
                  <v-flex xs6 class="mb-2 pl-2">
                    <input
                      :name="'จังหวัด' + k"
                      placeholder="(จังหวัด)"
                      type="text"
                      class="depainput rsu mb-0"
                      readonly
                  /></v-flex>
                  <v-flex xs6 class="mb-2 pr-2">
                    <input
                      :name="'แขวง/ตำบล' + k"
                      placeholder="(แขวง/ตำบล)"
                      type="text"
                      class="depainput rsu mb-0"
                      readonly
                  /></v-flex>
                  <v-flex xs6 class="mb-2 pl-2">
                    <input
                      :name="'เขต/อำเภอ' + k"
                      placeholder="(เขต/อำเภอ)"
                      type="text"
                      class="depainput rsu mb-0"
                      readonly
                  /></v-flex>
                </v-layout>
              </div>
              <div class="mb-2" v-if="['เลื่อนลง'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <DropdownMenu
                  v-model="formitem.defaultOptions"
                  :options="formitem.fields"
                  :textLabel="'label'"
                  :textValue="'label'"
                >
                  <div style="position: relative" class="form-control">
                    <input
                      :value="formitem.defaultOptions"
                      placeholder="เลือก"
                      type="text"
                      class="option-input rsu"
                      style="cursor: pointer"
                    />
                  </div>
                </DropdownMenu>
              </div>
              <div class="mb-2" v-if="['ช่องทำเครื่องหมาย'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <div v-for="(field, k) in formitem.fields" :key="k">
                  <v-checkbox
                    :readonly="isReadonly"
                    :disabled="isReadonly"
                    :value="field.label"
                    :label="field.label"
                    v-model="formitem.defaultOptions"
                    class="ma-0 mb-2"
                    outlined
                    hide-details
                    dense
                  >
                  </v-checkbox>
                  <div
                    class="pl-4"
                    v-if="
                      formitem.value &&
                        formitem.value.includes(field.label) &&
                        field.subquestion &&
                        field.subquestion.length
                    "
                  >
                    <FormDetailSubquestion
                      :formdata="{ formitems: field.subquestion }"
                      :showPreview="true"
                    ></FormDetailSubquestion>
                  </div>
                </div>
              </div>
              <div class="mb-2" v-if="['หลายตัวเลือก'].includes(formitem.questiontype)">
                <Typography
                  h5
                  semiBold
                  color="darkGrey"
                  :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
                  :label="formitem.name"
                />
                <v-radio-group
                  class="ma-0 d-block"
                  :readonly="isReadonly"
                  :disabled="isReadonly"
                  :value="formitem.defaultOptions"
                >
                  <div v-for="(field, k) in formitem.fields">
                    <v-radio class="mb-2" :key="k" :label="field.label" :value="field.label">
                    </v-radio>
                    <div
                      class="pl-4"
                      v-if="
                        (formitem.defaultOptions || []).includes(field.label) &&
                          field.subquestion &&
                          field.subquestion.length
                      "
                    >
                      <FormDetailSubquestion
                        :formdata="{ formitems: field.subquestion }"
                        :showPreview="true"
                      ></FormDetailSubquestion>
                    </div>
                  </div>
                </v-radio-group>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="mb-2 mt-1 center">
          <v-btn
            outline
            v-if="currentPage !== 0"
            @click="currentPage--"
            class="rsu customCancelBtn"
            depressed
            color="primary"
            ><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ
          </v-btn>
          <v-btn
            outline
            v-if="currentPage + 1 !== totalPage"
            @click="currentPage++"
            class="rsu customCancelBtn"
            depressed
            color="primary"
            >ถัดไป <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="mb-2 mt-1 center" v-if="totalPage == 1 || totalPage - 1 == currentPage">
          <v-btn class="rsu customCancelBtn" round outline color="primary">
            {{ formdata.reject ? formdata.reject : '-' }}
          </v-btn>
          <v-btn class="rsu customConfirmBtn" round depressed color="primary">
            {{ formdata.button ? formdata.button : '-' }}</v-btn
          >
        </v-flex>
      </v-layout>

      <!-- <v-layout row wrap justify-center>
        <v-flex xs4> </v-flex>
        <v-flex xs4>
          <div class="pt-2" v-if="totalPage == 1 || totalPage - 1 == currentPage">
            <div>
              <v-btn class="rsu" block style="border-radius: 7px" depressed color="primary">{{
                formdata.button ? formdata.button : '-'
              }}</v-btn>
            </div>
            <div>
              <v-btn class="rsu" block style="border-radius: 7px" outline color="primary">{{
                formdata.reject ? formdata.reject : '-'
              }}</v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xs4> </v-flex>
      </v-layout> -->
    </div>
    <!-- <div
      style="
        background-color: #152d53;
        color: white;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
        font-size: 24px;
        margin-bottom: 15px;
      "
    >
      {{ formdata.formname ? formdata.formname : 'ชื่อโครงการ' }}
    </div> -->
    <!-- <div class="px-4">
      <div v-for="(formitem, k) in allform" :key="k" class="form-control">
        <div class="grey--text" v-if="formitem.hideFromMember">
          *** Question นี้จะถูกซ่อนเมื่อสมาชิกมี Tax id
        </div>
        <div class="mb-2" v-if="['หัวข้อ', 'title', 'พารากราฟ'].includes(formitem.questiontype)">
          <p
            v-if="['พารากราฟ'].includes(formitem.questiontype)"
            style="color: black; white-space: pre-line"
          >
            {{ formitem.name }}
          </p>
          <template v-else-if="['หัวข้อ'].includes(formitem.questiontype)">
            <div class="headline primary--text" style="font-size: 21px">
              {{ formitem.name }}
            </div>
            <v-divider></v-divider>
          </template>
        </div>
        <div v-else>
          {{ formitem.name }}
        </div>
        <div v-if="['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ'].includes(formitem.questiontype)">
          <AutoresizeTextarea
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="textInputValue(formitem)"
            rows="1"
            outlined
            dense
          >
          </AutoresizeTextarea>
        </div>
        <div v-else-if="['ตัวเลข'].includes(formitem.questiontype)">
          <input
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="formitem.value"
            type="text"
            :maxlength="formitem.digitPosition || 1"
            class="depainput rsu"
          />
        </div>
        <div v-else-if="['ตัวอย่างไฟล์'].includes(formitem.questiontype)">
          <a :href="formitem.fileurl" target="_blank" download>{{ formitem.filename }}</a>
        </div>
        <div v-else-if="['ที่อยู่'].includes(formitem.questiontype)">
          <AutoresizeTextarea
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="addressInputValue(formitem, 'addressno')"
            rows="1"
            outlined
            placeholder="บ้านเลขที่"
            dense
            class="depainput rsu"
          >
          </AutoresizeTextarea>

          <input
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="addressInputValue(formitem, 'zipcode')"
            placeholder="รหัสไปรษณีย์"
            type="text"
            class="depainput rsu"
          />

          <input
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="addressInputValue(formitem, 'province')"
            placeholder="จังหวัด"
            type="text"
            class="depainput rsu"
          />

          <input
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="addressInputValue(formitem, 'amphoe')"
            placeholder="เขต/อำเภอ"
            type="text"
            class="depainput rsu"
          />

          <input
            style="color: grey !important"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="addressInputValue(formitem, 'district')"
            placeholder="แขวง/ตำบล"
            type="text"
            class="depainput rsu"
          />
        </div>
        <div v-else-if="formitem.questiontype == 'หลายตัวเลือก'">
          <v-radio-group
            :readonly="isReadonly"
            :disabled="isReadonly"
            :value="formitem.defaultOptions"
          >
            <v-radio
              :key="k"
              :label="field.label"
              v-for="(field, k) in formitem.fields"
              :value="field.label"
            >
            </v-radio>
          </v-radio-group>
          <div
            class="pl-4"
            v-if="value && selectedValue.subquestion && selectedValue.subquestion.length"
          >
            <FormDetailSubquestion
              :formdata="{ formitems: field.subquestion }"
              :showPreview="true"
            ></FormDetailSubquestion>
          </div>
        </div>
        <div v-else-if="formitem.questiontype == 'ช่องทำเครื่องหมาย'" class="mb-3">
          <div v-for="(field, k) in formitem.fields" :key="k">
            <v-checkbox
              v-model="formitem.defaultOptions"
              :readonly="isReadonly"
              :disabled="isReadonly"
              :value="field.label"
              outlined
              hide-details
              dense
              :label="field.label"
            >
            </v-checkbox>
            <div
              class="pl-4"
              v-if="
                nativeSelectedItems.includes(field.label) &&
                  field.subquestion &&
                  field.subquestion.length
              "
            >
              <FormDetailSubquestion
                :formdata="{ formitems: field.subquestion }"
                :showPreview="true"
              ></FormDetailSubquestion>
            </div>
          </div>
        </div>
        <div v-else-if="formitem.questiontype == 'เลื่อนลง'">
          <DropdownMenu :readonly="true" v-model="formitem.value" :options="formitem.fields">
            <input
              style="color: grey !important"
              :value="formitem.value"
              readonly
              type="text"
              class="depainput rsu"
            />
          </DropdownMenu>
        </div>
        <div v-else-if="formitem.questiontype == 'วัน/เวลา'">
          <v-layout row wrap>
            <v-flex v-if="['all', 'date'].includes(formitem.Options)" xs4>
              <div style="position: relative">
                <DatepickerCustomDialog :readonly="true" v-model="formitem.value">
                  <span>
                    <input
                      style="color: grey !important"
                      :value="depadateFormat(formitem.value)"
                      readonly
                      type="text"
                      class="depainput rsu"
                    />
                    <v-icon style="position: absolute; right: 4px; top: 6px; color: darkgrey"
                      >mdi-calendar</v-icon
                    >
                  </span>
                </DatepickerCustomDialog>
              </div>
            </v-flex>
            <v-flex v-if="['all', 'time'].includes(formitem.Options)" xs3 class="pl-2">
              <div style="position: relative">
                <CustomTimepicker :readonly="true" v-model="formitem.value2">
                  <span>
                    <input
                      style="color: grey !important"
                      :value="formitem.value2"
                      readonly
                      type="text"
                      class="depainput rsu"
                    />
                    <v-icon style="position: absolute; right: 4px; top: 6px; color: darkgrey"
                      >mdi-clock-time-eight-outline</v-icon
                    >
                  </span>
                </CustomTimepicker>
              </div>
            </v-flex>
          </v-layout>
        </div>

        <div
          v-else-if="
            ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(formitem.questiontype)
          "
        >
          <div>
            <div class="form-control">
              <div style="position: relative">
                <input
                  :value="formitem.value.length + ' ' + 'ไฟล์'"
                  class="depainput rsu pl-5"
                  readonly
                  type="text"
                  style="color: grey !important"
                />
                <div style="position: absolute; left: 10px; top: 5px">
                  <v-icon>file_upload</v-icon>
                </div>
              </div>
            </div>
          </div>

          <div v-if="typeof formitem.value == Array || typeof formitem.value == 'object'">
            <div v-for="(item, index) in formitem.value" :key="index" style="width: 100%">
              <div class="text-truncate">
                <span
                  style="font-weight: 900; color: #5da0c1; cursor: pointer"
                  @click="showItem(item)"
                >
                  {{ item | showFilename }}
                </span>
              </div>
            </div>
          </div>
          <div v-else>
            <div style="width: 100%">
              <div class="text-truncate">
                <span
                  style="font-weight: 900; color: #5da0c1; cursor: pointer"
                  @click="showItem(formitem.value)"
                >
                  {{ formitem.value | showFilename }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-layout row wrap justify-center>
        <v-flex xs4> </v-flex>
        <v-flex xs4>
          <div class="pt-2" v-if="totalPage == 1 || totalPage - 1 == currentPage">
            <div>
              <v-btn class="rsu" block style="border-radius: 7px" depressed color="primary">{{
                formdata.button ? formdata.button : '-'
              }}</v-btn>
            </div>
            <div>
              <v-btn class="rsu" block style="border-radius: 7px" outline color="primary">{{
                formdata.reject ? formdata.reject : '-'
              }}</v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xs4> </v-flex>
      </v-layout>
      <div>
        <v-layout row wrap>
          <v-flex xs6>
            <div class="pt-3">
              <v-btn
                outline
                large
                v-if="currentPage !== 0"
                @click="currentPage--"
                class="rsu px-3"
                style="border-radius: 7px"
                depressed
                color="primary"
                ><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ
              </v-btn>
            </div></v-flex
          >
          <v-flex xs6
            ><div class="text-xs-right pt-3">
              <v-btn
                outline
                large
                v-if="currentPage + 1 !== totalPage"
                @click="currentPage++"
                class="rsu px-3"
                style="border-radius: 7px; width: 112.86px"
                depressed
                color="primary"
                >ถัดไป <v-icon>mdi-chevron-right</v-icon></v-btn
              >
            </div></v-flex
          >
        </v-layout>
      </div>
    </div> -->
  </div>
</template>

<script>
import Typography from '@/components/elements/Typography.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import uploadfile from '@/components/elements/uploadfile.vue'
import FormDetailSubquestion from './FormDetailSubquestionPreview.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'

export default {
  props: ['formdata', 'showPreview'],

  components: {
    AutoresizeTextarea,
    DropdownMenu,
    uploadfile,
    FormDetailSubquestion,
    DatepickerCustomDialog,
    CustomTimepicker,
    Typography,
    DatePicker
  },
  data() {
    return {
      defaultAnswerOptions: [
        { label: '(ไม่มี)', value: '' },
        { label: 'ชื่อ', value: 'name' },
        { label: 'อีเมล', value: 'email' },
        { label: 'เบอร์โทรศัพท์', value: 'phone_number' },
        { label: 'หมายเลขบัตรประชาชน', value: 'id_card' },
        { label: 'เลขทะเบียนนิติบุคคล', value: 'id_card2' },
        { label: 'เลขประจำตัวผู้เสียภาษีอากร', value: 'id_card3' },
        { label: 'ทุนจดทะเบียน', value: 'regis_cap' },
        { label: 'ประเภทนิติบุคคล', value: 'membertype' },
        { label: 'Project Name', value: 'project_name' },
        { label: 'Member Type', value: 'membertype2' },
        { label: 'DP Status', value: 'dptype' },
        { label: 'Register Capital', value: 'RegisterCapital' },
        { label: 'Paid Register Capital', value: 'PaidRegisterCapital' },
        { label: 'เลขเกษตรกร', value: 'farmer_number' },
        { label: 'Member ID', value: 'u_memberid' },
        { label: '[Tech hunt] รหัสคูปอง (voucher)', value: 't_product_voucher' },
        { label: '[Tech hunt] ชื่อร้านค้า (DP) ', value: 't_shop_name' },
        { label: '[Tech hunt] ชื่อสินค้า', value: 't_product' },
        { label: '[Tech hunt] ประเภทสินค้า', value: 't_product_type' },
        { label: '[Tech hunt] หมวดหมู่สินค้า', value: 't_product_category' },
        { label: '[Tech hunt] member id ของ DP', value: 'shop_memberid' },
        { label: '[Tech hunt] เลขทะเบียนนิติบุคคลของ DP', value: 'shop_juristic_id' },
        { label: '[Tech hunt] หน่วยร่วม', value: 'agency' }
      ],
      defaultDateOptions: [
        { label: 'วันที่และเวลา', value: 'all' },
        { label: 'วันที่', value: 'date' },
        { label: 'เวลา', value: 'time' }
      ],
      // nativeSelectedItems: this.value ? [...this.value] : [],
      nativeSelectedItems: this.value ? [...this.value] : [],

      menu: false,

      optionsStatus: ['กล่องข้อความ', 'หลายตัวเลือก', 'เลื่อนลง', 'ช่องทำเครื่องหมาย'],
      input: {
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [''],
        fields2: ['']
      },
      currentPage: 0,
      totalPage: 1
    }
  },
  mounted() {
    console.log(this.allform)
    if (this.allform) {
      for (let i = 0; i < this.allform.length; i++) {
        if (this.allform[i].questiontype === 'ช่องทำเครื่องหมาย') {
          console.log(this.allform[i].defaultOptions)
          if (this.allform[i].defaultOptions) {
            this.nativeSelectedItems = this.allform[i].defaultOptions
          } else {
          }
        }
      }
      // if (this.formdata.questiontype == 'ช่องทำเครื่องหมาย') {
      //   let defaultOptiones = this.formdata.defaultOptions.filter(el => {
      //     return this.formdata.fields.some(el => el.label)
      //   })

      //   this.valueData = defaultOptiones
      //   this.nativeSelectedItems = defaultOptiones
      //   this.onInputArray()
      // } else if (this.formdata.questiontype == 'หลายตัวเลือก') {
      //   let defaultOptiones = this.formdata.fields.find(
      //     el => el.label == this.formdata.defaultOptions
      //   )
      //   this.valueData = defaultOptiones ? defaultOptiones.label : ''
      // }
    }
  },
  computed: {
    isReadonly() {
      return true
    },
    selectedValue() {
      if (this.value) {
        return this.formitem.fields.find(el => el.label == this.value)
      }
    },
    allform() {
      var result = this.formdata.formitems
      if (result.some(el => el.questiontype == 'หน้าถัดไป')) {
        var data = []
        var count = 0
        // eslint-disable-next-line no-continue
        result.map((el, index) => {
          if (el.questiontype == 'หน้าถัดไป') {
            count += 1
          } else {
            // eslint-disable-next-line no-continue4
            if (data[count]) {
              data[count].push(el)
            } else {
              data.push([el])
            }
          }
        })
        this.totalPage = data.length
        return data[this.currentPage]
      } else {
        return result
      }
    }
  },
  methods: {
    customPlaceholder(text) {
      for (let i = 0; i < this.defaultAnswerOptions.length; i++) {
        if (this.defaultAnswerOptions[i].value === text) {
          if (text != ('(ไม่มี)' && '' && null && undefined)) {
            return `(${this.defaultAnswerOptions[i].label})`
          } else {
            return ``
          }
        }
      }
    },
    customDateOptions(text) {
      for (let i = 0; i < this.defaultDateOptions.length; i++) {
        if (this.defaultDateOptions[i].value === text) {
          return `${this.defaultDateOptions[i].label}`
        }
      }
    },
    addressInputValue(formitem, type) {
      let address = {
        addressno: '',
        district: '',
        amphoe: '',
        province: '',
        zipcode: ''
      }

      if (formitem && formitem.value && type) {
        try {
          address = JSON.parse(formitem.value)
          if (address.hasOwnProperty(type)) {
            return address[type]
          }
        } catch (error) {}
      }
      return ''
    },
    textInputValue(formitem) {
      if (formitem && formitem.Options) {
        console.log('asd', this.defaultAnswerOptions)
        return `{ ${this.defaultAnswerOptions.find(el => el.value == formitem.Options).label} }`
      } else return formitem.value
    },
    depadateFormat(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    },
    showItem(item) {
      window.open(item, '_blank').focus()
    },
    deleteItem(item) {
      console.log(item)
    }
  },
  filters: {
    showFilename(value) {
      var result = value
      if (result) {
        result = result.split('/')
        result = result[4].substring(13)
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.ab-close-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.viewModal {
  border-radius: 8px;
  .viewModalHeader {
    position: sticky;
    top: 0;
    z-index: 999;
    display: flex;
    background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 0px 0px;
    padding: 22px 52px 10px 52px;
    max-height: 150px;
  }
  .viewModalSubHeader {
    position: sticky;
    top: 87px;
    z-index: 999;
    .subContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 35px;
      background: linear-gradient(89.72deg, #fff200 6.51%, #ffc600 93.28%);
    }
  }
  .viewModalBody {
    padding: 10px 52px;
    // height: 95vh;
    // overflow-y: auto;
  }
  .customCancelBtn {
    font-weight: 700;
    font-size: 16px;
    width: 142px;
    margin: 0 7px;
  }
  .customConfirmBtn {
    color: yellow !important;
    font-weight: 700;
    font-size: 16px;
    width: 142px;
    margin: 0 7px;
  }
  .customExamfileBtn {
    background-color: #e6f0fb !important;
    color: #26588b !important;
    font-weight: 700;
    font-size: 16px;
    width: 165px;
    .customBtnText {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .dataReq {
    display: flex;
  }
  .dataReq::after {
    content: '*';
    color: red;
  }
  .uploadBtn {
    width: 185px;
  }
}

.generate-table-container {
  width: 100%;
  max-height: 350px;
  overflow-x: auto;
  overflow-y: auto;
}
.generate-table-container::-webkit-scrollbar {
  -webkit-appearance: none;
  background: #eeeeee;
  border-radius: 20px;
}
.generate-table-container::-webkit-scrollbar:vertical {
  width: 13px;
}

.generate-table-container::-webkit-scrollbar:horizontal {
  height: 13px;
}

.generate-table-container::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 3px solid #eeeeee;
  background-color: #0c2f53;
}
table.form-generate-table {
  table-layout: fixed;
  width: max-content;
  thead {
    tr {
      border-bottom: 1px solid #d9d9d9;
      th {
        width: 162px;
        padding: 8px 0px;
        position: relative;
        border-radius: 0px;
        background-color: #eeeeee;
        img.table-ico {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      th:first-child {
        background-color: #bdbdbd;
      }
      th:not(:first-child)::after {
        content: '';
        border-left: 1px solid #d9d9d9;
        position: absolute;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #d9d9d9;
      td {
        padding: 8px 0px;
        border-radius: 0px;
        position: relative;
        img.table-ico {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      td:first-child {
        background-color: #eeeeee;
      }
      td:not(:first-child)::after {
        content: '';
        border-left: 1px solid #d9d9d9;
        position: absolute;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/FormDetail.vue